import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import EvaluatorService from '../../../Services/EvaluatorService';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import PersonaExportItem from './PersonaExportItem';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import ErrorMessage from '../../../Elements/ErrorMessage';
import EvaluatorPersonaAndSchedulingSearchParams from './EvaluatorPersonaAndSchedulingSearchParams';

class EvaluatorPersonaExportAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    const searchItem = new EvaluatorPersonaAndSchedulingSearchParams();

    this.state = {
      shownPanel: ShownPanelsEnum.Search,
      searchItem,
      orderDirection: 'Asc',
      selected: -1,
      selectedEvaluator: null,
      shownOverWindow: ShownOverWindowsEnum.None,
      tipaltiEvaluator: null,
      evaluatorList: [],
      cleared: process.env.NODE_ENV !== 'development',
    };
    this.startSearch = this.startSearch.bind(this);
    this.handleExportOnClick = this.handleExportOnClick.bind(this);
  }

  startSearch(searchItem) {
    this.setState({
      searchItem,
      cleared: false,
    });
  }

  handleExportOnClick() {
    ReportRunnerService.ExportPersonaReportToExcel(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('EA193')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={PersonaExportItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={EvaluatorService.GetPersonaExportEvaluators}
          convertDBItemsFunction={EvaluatorService.ConvertDBEvaluator}
          searchParamsType={EvaluatorPersonaAndSchedulingSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          cleared={this.state.cleared}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different id, name or email...'
          errorCode='EPEA110'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportOnClick}
        />
      </div>
    );
  }
}

export default EvaluatorPersonaExportAdmin;
